import { RowCrudStatus } from "../../common/types";
import {
  ShowcaseLine,
  ShowcaseLine_CreateInput,
  ShowcaseLine_UpdateInput,
} from "../../../api/graphql";
import { LangStore } from "../../../store";
import { blankToNull } from "../../../common/blankToNull";

export type ShowcaseLineValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  concept: string;
  quantity: number;
  unitPrice: number;
  note: string;
};

export type ShowcaseLineErrorsType = {
  concept?: { message: string; fieldLabel: string };
  quantity?: { message: string; fieldLabel: string };
  unitPrice?: { message: string; fieldLabel: string };
  note?: { message: string; fieldLabel: string };
};

export function ShowcaseLineValuesInit(): ShowcaseLineValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    concept: "",
    quantity: 0,
    unitPrice: 0,
    note: "",
  };
}

export type ShowcaseLineType = ShowcaseLine | ShowcaseLineValuesType;

export function showcaseLineDisplayId(
  source: Partial<ShowcaseLine>,
  _langStore: LangStore
) {
  return source.concept ?? _langStore.emptyStringSymbol;
}

export function getShowcaseLineValues(
  source: ShowcaseLineType,
  _langStore: LangStore,
  _duplicated: boolean = false
): ShowcaseLineValuesType {
  const entityValues = ShowcaseLineValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : showcaseLineDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.concept = source.concept;
  entityValues.quantity = source.quantity || 0;
  entityValues.unitPrice = Number(source.unitPrice) || 0;
  entityValues.note = source.note || "";
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}

export function getShowcaseLineUpdateInput(
  values: ShowcaseLineValuesType
): ShowcaseLine_UpdateInput {
  return {
    id: values.id,
    version_: values.version_,
    concept: values.concept,
    quantity: values.quantity,
    unitPrice: values.unitPrice,
    note: blankToNull(values.note),
  };
}

export function getShowcaseLineCreateInput(
  values: ShowcaseLineValuesType
): ShowcaseLine_CreateInput {
  return {
    concept: values.concept,
    quantity: values.quantity,
    unitPrice: values.unitPrice,
    note: blankToNull(values.note),
  };
}
